var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 62,
    viewBox: "0 0 65 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 45.375,
    cy: 20.375,
    r: 19.375,
    fill: "#DE6161"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2084 18.6146H51.0417",
    stroke: "#DE6161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5209 28.8229V44.1354",
    stroke: "#DE6161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7291 28.8229V44.1354",
    stroke: "#DE6161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7604 18.6146L15.3125 49.2396C15.3125 50.5933 15.8502 51.8916 16.8074 52.8488C17.7647 53.806 19.0629 54.3438 20.4166 54.3438H40.8333C42.187 54.3438 43.4853 53.806 44.4425 52.8488C45.3997 51.8916 45.9375 50.5933 45.9375 49.2396L48.4895 18.6146",
    stroke: "#DE6161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 18.6146V10.9583C22.9688 10.2815 23.2376 9.63235 23.7162 9.15374C24.1948 8.67513 24.844 8.40625 25.5208 8.40625H35.7292C36.406 8.40625 37.0552 8.67513 37.5338 9.15374C38.0124 9.63235 38.2812 10.2815 38.2812 10.9583V18.6146",
    stroke: "#DE6161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.78368de8a00e26c92a19ddbca22201a7.svg";
export { ForwardRef as ReactComponent };